export const PAGE_TITLES = {
  DEFAULT: 'My Hivve'
};
